import axios from "axios";
import { buildTimerStartPostData } from "../services/trackerServices";
import { persistTimerStartData } from "./timerStartHelpers";
import { secureSetItem, STORAGE_KEYS } from "./secureStorage";
import { setRunningTaskData } from "../../../../../features/timeTrackerData/timeTrackerLogSlice.js";

/**
 * Handles the API call to start a timer and persists the response
 * Extracted from handleStartClick for better separation of concerns
 */
export const startTimerApiCall = async ({
  token,
  time,
  taskName,
  projectName,
  projectId,
  tag,
  tagId,
  client,
  clientId,
  isBillable,
  sprintName,
  sprintId,
  selectedUser,
  dispatch,
  setTrackTask,
  toast,
  toastConfig,
}) => {
  // Build post data using service function
  const postData = buildTimerStartPostData({
    taskName,
    projectName,
    projectId,
    tag,
    tagId,
    startTime: time,
    selectedUser,
    client,
    clientId,
    isBillable,
    sprintName,
    sprintId,
  });

  try {
    const response = await axios.post("/api/time-track/start-timer", postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Persist running task ID
    if (response.data.id) {
      setTrackTask(response.data.id);
      secureSetItem(STORAGE_KEYS.RUNNING_TASK, response.data.id);
      dispatch(setRunningTaskData(response.data.id));
    }

    return { success: true, data: response.data };
  } catch (apiError) {
    console.error("API Error while starting timer:", apiError);
    throw apiError;
  }
};
